import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from "react-intl";
import {formatNumber, getComparativeValue} from "./utils";
import {ComparativeValue} from "components/Analytics/constants";

interface TotalsProps {
  totals: string;
  growthpct: number;
}

export const Totals: React.FC<TotalsProps> = props => {
  const { totals, growthpct } = props;
  const comparativeValue = getComparativeValue(growthpct);
  return (
    <Container>
      <Total>
        <TotalName>{formatNumber(totals) || '-'}</TotalName>
        <SamePeriod>
          <FormattedMessage
            id="Analytics.Totals.SamePeriod"
            defaultMessage="for the same period"
          />
        </SamePeriod>
      </Total>
      <GrowthPCT comparativeValue={comparativeValue}>
        {growthpct || '0'}% {(() => {
          if (comparativeValue === ComparativeValue.Less) {
            return (
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.29289 21.7071C7.68342 22.0976 8.31658 22.0976 8.70711 21.7071L15.0711 15.3431C15.4616 14.9526 15.4616 14.3195 15.0711 13.9289C14.6805 13.5384 14.0474 13.5384 13.6569 13.9289L8 19.5858L2.34315 13.9289C1.95262 13.5384 1.31946 13.5384 0.928933 13.9289C0.538408 14.3195 0.538408 14.9526 0.928933 15.3431L7.29289 21.7071ZM8 0L7 4.37114e-08L7 21L8 21L9 21L9 -4.37114e-08L8 0Z" fill="#FF6565"/>
              </svg>
            );
          }

          if (comparativeValue === ComparativeValue.More) {
            return (
              <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.70711 0.292892C8.31658 -0.0976315 7.68342 -0.0976315 7.29289 0.292892L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292892ZM8 22L9 22L9 1L8 1L7 1L7 22L8 22Z" fill="#1DB954"/>
              </svg>
            );
          }

          return null;
      })()}
      </GrowthPCT>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const Total = styled.div`
  display: flex;
  gap: 6px;
  align-items: flex-end;
`;

const TotalName = styled.div`
  font-weight: 500;
  font-size: 30px;
  leading-trim: NONE;
  line-height: 33px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

const SamePeriod = styled.div`
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #00000080;
`;

const GrowthPCT = styled.div<{ comparativeValue: ComparativeValue }>`
  color: ${props => {
      if (props.comparativeValue === ComparativeValue.Less) {
        return '#FF6565';
      }
  
      if (props.comparativeValue === ComparativeValue.More) {
        return '#1DB954';
      }
      
      return "#000000";
  }};
  font-family: Outfit;
  font-weight: 500;
  font-style: Medium;
  font-size: 30px;
  leading-trim: NONE;
  line-height: 33px;
  letter-spacing: 0%;
  vertical-align: middle;
`;
